import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from "@react-spectrum/s2";
import { AppScreenTitle } from '../common';
import { Chat, History, ChartBarVert, Upload, AIChatIllustration, DropToUploadIllustration, GraphBarChartIllustration, ClockIllustration } from '../icons/s2';
import './EmptyStateView.css';
import './SiteLandingView.css';
// =============================================================================
// Component
// =============================================================================
export interface SiteLandingViewProps {
    siteName: string;
    onStartChat: () => void;
    onChatHistory: () => void;
    onAddContent: () => void;
    onAnalytics: () => void;
    canManageContent: boolean;
    canManageSite: boolean;
}
export const SiteLandingView: React.FC<SiteLandingViewProps> = ({ siteName, onStartChat, onChatHistory, onAddContent, onAnalytics, canManageContent, canManageSite })=>{
    const { t } = useTranslation();
    return (<div className="site-landing-page">
      <AppScreenTitle title={t('settings.siteLanding.overview')} context={siteName}/>
      <div className={"empty-state-container" + " sd171 _ta171 eb171 _Cg171 _Coa171 _ub171 _vb171 _sb171"}>
        <p className="site-landing__intro">{t('settings.siteLanding.intro')}</p>

        <div className="site-landing-grid">
          <div className="site-landing-card site-landing-card--chat">
            <div className="site-landing-card__icon" aria-hidden>
              <AIChatIllustration/>
            </div>
            <div className="site-landing-card__content">
              <div className="site-landing-card__text">
                <h2 className="site-landing-card__title">{t('settings.siteLanding.chatTitle')}</h2>
                <p className="site-landing-card__desc">
                  {t('settings.siteLanding.chatDesc')}
                </p>
              </div>
              <Button variant="secondary" UNSAFE_className="site-landing-card__cta" onPress={onStartChat}>
                <Chat/>
                <Text>{t('settings.siteLanding.chatCta')}</Text>
              </Button>
            </div>
          </div>

          <div className="site-landing-card site-landing-card--history">
            <div className="site-landing-card__icon" aria-hidden>
              <ClockIllustration/>
            </div>
            <div className="site-landing-card__content">
              <div className="site-landing-card__text">
                <h2 className="site-landing-card__title">{t('settings.siteLanding.historyTitle')}</h2>
                <p className="site-landing-card__desc">
                  {t('settings.siteLanding.historyDesc')}
                </p>
              </div>
              <Button variant="secondary" UNSAFE_className="site-landing-card__cta" onPress={onChatHistory}>
                <History/>
                <Text>{t('settings.siteLanding.historyCta')}</Text>
              </Button>
            </div>
          </div>

          {canManageContent && (<div className="site-landing-card site-landing-card--content">
              <div className="site-landing-card__icon" aria-hidden>
                <DropToUploadIllustration/>
              </div>
              <div className="site-landing-card__content">
                <div className="site-landing-card__text">
                  <h2 className="site-landing-card__title">{t('settings.siteLanding.contentTitle')}</h2>
                  <p className="site-landing-card__desc">
                    {t('settings.siteLanding.contentDesc')}
                  </p>
                </div>
                <Button variant="secondary" UNSAFE_className="site-landing-card__cta" onPress={onAddContent}>
                  <Upload/>
                  <Text>{t('settings.siteLanding.contentCta')}</Text>
                </Button>
              </div>
            </div>)}

          {canManageSite && (<div className="site-landing-card site-landing-card--analytics">
              <div className="site-landing-card__icon" aria-hidden>
                <GraphBarChartIllustration/>
              </div>
              <div className="site-landing-card__content">
                <div className="site-landing-card__text">
                  <h2 className="site-landing-card__title">{t('settings.siteLanding.analyticsTitle')}</h2>
                  <p className="site-landing-card__desc">
                    {t('settings.siteLanding.analyticsDesc')}
                  </p>
                </div>
                <Button variant="secondary" UNSAFE_className="site-landing-card__cta" onPress={onAnalytics}>
                  <ChartBarVert/>
                  <Text>{t('settings.siteLanding.analyticsCta')}</Text>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </div>);
};
export default SiteLandingView;

import "macro-7fa66b34e2cea79a1621ff20afa573545edbe1bb5f8c9e5ca95c0342b74382f1.css";